import React from 'react'
import { Space } from 'antd'
import styles from './UploadControl.module.scss'
import { useComponentLocale } from '../hooks/useComponentLocale'

function UploadInfo({ uploadRequest, uploadedFilesList, uploadFileRequestState }) {
	const getLocale = useComponentLocale()
	const processedLocale = getLocale({ component: 'tags', section: 'processed' })
	const duplicatesLocale = getLocale({ component: 'tags', section: 'duplicates' })
	const stackOutOfRangeLocale = getLocale({ component: 'tags', section: 'stack_out_of_range' })
	const notInSpotListLocale = getLocale({ component: 'tags', section: 'not_in_spot_list' })

	return (
		<>
			{(uploadRequest || uploadedFilesList.length) && uploadFileRequestState ? (
				<div className={styles.uploadData}>
					<Space>
						<span>
							{processedLocale}:{' '}
							<span className={styles.valueText}>{uploadFileRequestState.progressOverall?.parsed}</span>
						</span>
						<span>
							{duplicatesLocale}:{' '}
							<span className={styles.valueText}>{uploadFileRequestState.progressOverall?.duplicate}</span>
						</span>
						<span>
							{stackOutOfRangeLocale}:{' '}
							<span className={styles.valueText}>{uploadFileRequestState.progressOverall?.stack}</span>
						</span>
						<span>
							{notInSpotListLocale}:{' '}
							<span className={styles.valueText}>{uploadFileRequestState.progressOverall?.other}</span>
						</span>
					</Space>
				</div>
			) : null}
		</>
	)
}

export default UploadInfo
